import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Container, Col, Row, Button, Dropdown, DropdownButton, Table, Tabs, Tab} from "react-bootstrap";
import { Calendar4, ExclamationCircle, Check2Circle, ArrowClockwise } from 'react-bootstrap-icons';

import { SingleDatePicker } from "react-dates"; 
import "react-dates/lib/css/_datepicker.css";

import moment from 'moment';

import NavbarComponent from '../components/NavbarComponent';
import FooterComponent from '../components/FooterComponent';
import AuthErrorComponent from '../components/AuthErrorComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import ServerErrorComponent from '../components/ServerErrorComponent';
import LoadingComponent from '../components/LoadingComponent';

//import {DELIVERY_LINES} from '../constants/DeliveryLines';
import {NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN, BAD_REQUEST_400} from '../constants/ApiResult';

import {
    getBranchByAllDeliveryLine
} from "../services/Branch";

import {
    getInventoryBranchMapping,
    getSupplierDeliveryLines,
    getTemporaryDeliveryLines,
    getSupplierPurchaseOrderStorageDates,
    getDeliveryLinesQualityAssurance
} from "../services/Supplier";

import {
    getPurchaseOrdersItemsQty,
    getPurchaseOrdersItemsByPOId
} from "../services/PurchaseOrder";

const cjson = require('compressed-json');

//const axios = require('axios').default;
//const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal';
const DEPARTMENT_DEFAULT = "採購部";

  const productGroupings = [
      {
        groupId: 1,
        groupName: "Column 1",
        itemIdLists: [
          {
            listId: 1,
            listName: "Group 1",
            itemIds: [430, 432, 433]  // Reference the itemIds from a product array
          },
          {
            listId: 2,
            listName: "Group 2",
            itemIds: [431]
          }
        ]
      },
      {
        groupId: 2,
        groupName: "Column 2",
        itemIdLists: [
          {
            listId: 3,
            listName: "Group 3",
            itemIds: [437]
          },
          {
            listId: 4,
            listName: "Group 4",
            //itemIds: [440]
            itemIds: [438]
          }
        ]
      },
      {
        groupId: 3,
        groupName: "Column 3",
        itemIdLists: [
          {
            listId: 5,
            listName: "Group 5",
            itemIds: [448, 449, 450, 451, 452]
          },
          {
            listId: 6,
            listName: "Group 6",
            //itemIds: [438]
            itemIds: [445]
          },
          {
            listId: 7,
            listName: "Group 7",
            //itemIds: [445]
            itemIds: [440]
          }
        ]
      },
      {
        groupId: 4,
        groupName: "Column 4",
        itemIdLists: [
          {
            listId: 8,
            listName: "Group 8",
            itemIds: [441, 442, 443, 444]
          }
        ]
      },
      {
        groupId: 5,
        groupName: "Column 5",
        itemIdLists: [
          {
            listId: 9,
            listName: "Group 9",
            itemIds: [434, 435, 446, 447]
          }
        ]
      }
    ]

class SupplierLogisticsPickLoose extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            authError:false,
            serverError:false,
            apiErrorMessage:'',
            isLoading:false,
            deliveryLine:0,
            branchesAPI:false,
            branchesData:[],
            inventoryMappingAPI:false,
            inventoryMappingData:[],
            purchaseOrdersItemsQtyAPI:false,
            purchaseOrdersItemsQtyData:[],
            goodsFormatData:[],
            productsData:[],
            purchaseOrdersItemsByPOIdAPI:false,
            purchaseOrdersItemsData:[],
            requestedDeliveryDate:moment().add(1, 'days'),
            deliveryLinesAPI:false,
            deliveryLinesData:[],
            temporaryDeliveryLinesAPI:false,
            temporaryDeliveryLinesData:[],
            poStorageDatesAPI:false,
            poStorageDatesData:[],
            deliveryLinesQAData:[],
            deliveryLinesQAAPI:false,
            looseTabActive:false
        }

        this.SingleDatePickerDates = [];
        this.totalLooseProducts = [];
        this.grandTotalGroupedProducts = 0;
        this.grandTotalGroupedLooseProducts = 0;
    }

    componentDidMount() {
        if(!this.props.auth.suppliersConfig) {
            this.setState({
                authError:true
            });
        } else {
            this.getSupplierPurchaseOrderStorageDates();
            this.getSupplierDeliveryLinesAPI();
            this.getBranchesAPI();
            this.getInventoryBranchMappingAPI();
            this.getPurchaseOrdersItemsByPOIdAPI();
        }
    }

/*
API
*/

    handleResponseAPI = (data) => {
        if (
            [NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(
              data
            ) > -1
          ) {
            this.setState({
              isLoading: false,
              authError: true,
            });
            return;
          }
    }
    
    handleServerErrorAPI = (err) => {
        this.setState(
          {
            isLoading: false,
            serverError: true,
          },
          () => {
            if (err) console.log(err);
          }
        );
      };

      handleErrorAPI = (err) => {
        if(!err) {
            err = BAD_REQUEST_400;
        }
        this.setState(
          {
            isLoading: false,
            apiErrorMessage: err,
          },
          () => {
            if (err) console.log(err);
          }
        );
      };

// (GET) Branches
    getBranchesAPI = async () => {
        try {
            const props = {
                supplierId: this.props.auth.supplierId,
                token: this.props.auth.token
            };
            
            let res = await getBranchByAllDeliveryLine(props);
            let data = res.data.data;

            this.handleResponseAPI(res.data.result);

            data.forEach( (obj, index) => {
                obj.Inactive = true;
            });

            if(data.length > 0) {
                this.setState({
                    branchesData:data,
                    branchesAPI:true
                }, () => {
                    this.getTemporaryDeliveryLinesAPI();
                    this.getPurchaseOrdersItemsQtyAPI();
                })
            } else {
                this.handleErrorAPI();
            }
        
        } catch (err) {
            this.handleServerErrorAPI(err);
        }
    }

// (GET) Inventory Branch Mapping
    getInventoryBranchMappingAPI = async () => {
        try {
            const props = {
                supplierId: this.props.auth.supplierId,
                token: this.props.auth.token
            };
            
            let res = await getInventoryBranchMapping(props);
            let data = cjson.decompress(res.data.data);
            //console.log("InventoryBranchMapping Filtered: ", testData)
            //console.log("InventoryBranchMapping: ", data)

            this.handleResponseAPI(res.data.result);

            if(data.length >= 0) {
                let products = this.getProducts(data);
                this.setState({
                    inventoryMappingData:data,
                    inventoryMappingAPI:true,
                    productsData:products,
                });
            } else {
                this.handleErrorAPI();
            }
            
        } catch (err) {
            this.handleServerErrorAPI(err);
        }
    }

// (GET) Purchase Orders Items Qty
    getPurchaseOrdersItemsQtyAPI = async () => {
        let from = `${moment(this.state.requestedDeliveryDate).format('YYYY-MM-DD')+' 00:00:00'}`;
        let to = `${moment(this.state.requestedDeliveryDate).format('YYYY-MM-DD')+' 23:59:59'}`;
        try {
            const props = {
                supplierId: this.props.auth.supplierId,
                from: from,
                to: to,
                token: this.props.auth.token
            };
            
            let res = await getPurchaseOrdersItemsQty(props);
            let data = res.data.data;

            this.handleResponseAPI(res.data.result);

            let branchesData = JSON.parse(JSON.stringify(this.state.branchesData));
            let branchIndex = 0;
            data.forEach( (product) => {

                // set active branches
                if(product.Num > 0) {

                    // may cause issue if branch and deliveryLine is not 1:1
                    branchIndex = branchesData.findIndex ( (obj) => obj.branchCode === product.BranchCode && obj.DepId === product.DepId );
                    
                    if(branchIndex > -1) {
                        branchesData[branchIndex].Inactive = false;
                    }
                }

                if(product.GoodsFormatId > 0) {
                    let goodsFormatData = res.data.goodsFormatData.filter( (obj) => obj.GoodsFormatId === product.GoodsFormatId)[0];                    
                    if(goodsFormatData) {
                        product.GoodsFormatName = goodsFormatData.GoodsFormatName;
                    }
                }

            });
           
            // merge the response.goodsFormatData with the response.data
            let goodsFormatData = data.goodsFormatData;

            //
            // delivery line qa
            //

            const resQA = await getDeliveryLinesQualityAssurance({
                supplierId: this.props.auth.supplierId,
                storageDate: moment(this.state.requestedDeliveryDate).format('YYYY-MM-DD'),
                token: this.props.auth.token
            });

            const dataQA = resQA.data.data;
    
            this.handleResponseAPI(resQA.data.result);
    
            this.setState({
                isLoading: false,
                purchaseOrdersItemsQtyData:data,
                goodsFormatData:goodsFormatData,
                purchaseOrdersItemsQtyAPI:true,
                branchesData:branchesData,
                deliveryLinesQAData:dataQA,
                deliveryLinesQAAPI:true
            });
            
        } catch (err) {
            this.handleServerErrorAPI(err);
        }
    }

// (GET) Purchase Orders Items By POId
    getPurchaseOrdersItemsByPOIdAPI = async () => {
        try {
            const props = {
                poId: JSON.stringify([this.props.auth.suppliersConfig.poId]),
                token: this.props.auth.token
            };
            
            let res = await getPurchaseOrdersItemsByPOId(props);
            let data = res.data.data;
            this.handleResponseAPI(res.data.result);
            
            this.setState({
                purchaseOrdersItemsData:data,
                purchaseOrdersItemsByPOIdAPI:true
            });

        } catch (err) {
            this.handleServerErrorAPI(err);
        }       
    }

// (GET) Supplier Delivery Lines
    getSupplierDeliveryLinesAPI = async () => {
        try {
            const props = {
                supplierId: this.props.auth.supplierId,
                token: this.props.auth.token
            };
            
            let res = await getSupplierDeliveryLines(props);
            let data = res.data.data;

            this.handleResponseAPI(res.data.result);
            
            this.setState({
                deliveryLinesData:data,
                deliveryLinesAPI:true
            });

        } catch (err) {
            this.handleServerErrorAPI(err);
        }
    }

    // (GET) Temporary Delivery Lines
    getTemporaryDeliveryLinesAPI = async () => {
        try {
            const { auth } = this.props;
            const { requestedDeliveryDate, deliveryLinesData, branchesData } = this.state;
            const props = {
                supplierId: auth.supplierId,
                date: moment(requestedDeliveryDate).format('YYYY-MM-DD'),
                token: auth.token,
            };

            const res = await getTemporaryDeliveryLines(props);
            const { data } = res.data;
            this.handleResponseAPI(res.data.result);

            const _transferLines = Array.from(new Set(data.map((element) => element.tempDeliveryLine))).sort();
            const setTransferLines = deliveryLinesData.filter(obj => !obj.transferLine);
            const setBranchTransfer = branchesData.map(branch => {
                const transferRecord = data.findIndex(tran => tran.branchId === branch.BranchId);

                if (transferRecord === -1) {
                    return {
                        ...branch,
                        transferLine: -1
                    };
                }

                return {
                    ...branch,
                    transferLine: data[transferRecord].tempDeliveryLine,
                    transferSortOrder: data[transferRecord].sortOrder
                };
            });

            setBranchTransfer.sort((a, b) => a.transferSortOrder - b.transferSortOrder);

            const transferLines = _transferLines.map(tl => ({
                DeliveryId: tl,
                Label: `${tl} - 分流線${tl === 18 ? "1" : tl === 19 ? "2" : ""}`,
                SupplierId: auth.supplierId,
                transferLine: true
            }));

            this.setState({
                deliveryLinesData: [...setTransferLines, ...transferLines],
                branchesData: setBranchTransfer,
                temporaryDeliveryLinesData: data,
                temporaryDeliveryLinesAPI: true
            });

            // console.log("Updated Branches Data: ", this.state.branchesData)
        } catch (err) {
            this.handleServerErrorAPI(err);
        }
    };

// (GET) Supplier Purchase Order Storage Dates
getSupplierPurchaseOrderStorageDates = async () => {
    try {
        const props = {
            supplierId: this.props.auth.supplierId,
            token: this.props.auth.token
        };
        
        let res = await getSupplierPurchaseOrderStorageDates(props);
        let data = res.data.data;

        this.handleResponseAPI(res.data.result);
        
        this.setState({
            poStorageDatesData:data,
            poStorageDatesAPI:true
        });

    } catch (err) {
        this.handleServerErrorAPI(err);
    }
}

// (GET) Supplier Delivery Lines QA
/*
getDeliveryLinesQualityAssuranceAPI = async  () => {
    try {
        const props = {
            supplierId: this.props.auth.supplierId,
            storageDate: moment(this.state.requestedDeliveryDate).format('YYYY-MM-DD'),
            token: this.props.auth.token
        };
        
        let res = await getDeliveryLinesQualityAssurance(props);
        let data = res.data.data;

        this.handleResponseAPI(res.data.result);

        console.log(data);
        
        this.setState({
            deliveryLinesQAData:data,
            deliveryLinesQAAPI:true
        });

    } catch (err) {
        this.handleServerErrorAPI(err);
    }
}
*/

/*
Refresh
*/

    handleOnClickRefresh = () => {
        this.setState({
            isLoading:true
        }, () => {
            this.getInventoryBranchMappingAPI();
            this.getPurchaseOrdersItemsByPOIdAPI();
            this.getPurchaseOrdersItemsQtyAPI();
        });
        
    }

/*
Branches
*/

    resetBranchesDataInactive = () => {
        let data = JSON.parse(JSON.stringify(this.state.branchesData));
        data.forEach( (branch, index) => {
            data[index].Inactive = true;
        });
        return data;
    }


/*
Drop Down Delivery Line
*/

    handleOnSelectDeliveryLine = (line) => {
        this.setState({
            deliveryLine:parseInt(line),
            //branchesData:this.resetBranchesDataInactive()
        });
    }

    getDeliveryLineTitle =  () => {
        let data = this.state.deliveryLinesData.filter( (obj) => obj.DeliveryId === parseInt(this.state.deliveryLine) )[0];
        if(data) {
            return `${data['Label']}`;
        } else {
            return this.state.deliveryLine;
        }
    }

    getDeliveryLineDropDownTitle = () => {
        if(this.state.deliveryLine > 0) {
            return this.getDeliveryLineTitle();
        }
        return "Select Delivery Line";
    }   

    htmlDropDownItems = () => {
        let branchesData = [];
        return this.state.deliveryLinesData.map( (row, index) => {
            if(row?.transferLine){
                branchesData = this.state.branchesData.filter( (obj) => obj.transferLine === row.DeliveryId );
            } else {
                branchesData = this.state.branchesData.filter( (obj) => obj.DeliveryLine === row.DeliveryId );
            }

            let isPO = false;
            
            branchesData.forEach( (row) => {
                let branchDepPurchaseOrders = this.getBranchDepPurchaseOrders(row.branchCode, row.DepId);
                if(branchDepPurchaseOrders.length) {
                    isPO = true;
                }
            });

            return (
                <Dropdown.Item eventKey={row.DeliveryId} key={index}>
                    {row.Label}
                    {isPO && <Check2Circle size={16} className="ml-1" />}
                </Dropdown.Item>
            )
        });
    }

/*
Table
*/

    getTableLogisticsInactive = (branchCode, depId) => {
        let branchData = this.state.branchesData.filter( (obj) => obj.branchCode === branchCode && obj.DepId === depId && obj.DeliveryLine === this.state.deliveryLine )[0];
        if(branchData) {
            return branchData.Inactive;
        }
        return true;
    }

    /*
    setTableLogisticsInactive = (array, state) => {
        let data = JSON.parse(JSON.stringify(this.state.branchesData));
        let index = 0;
        array.forEach( (row) => {
            if(row.depId > 0) {
                index = data.findIndex ( (obj) => obj.branchCode === row.branchCode && obj.DepId === row.depId && obj.DeliveryLine === this.state.deliveryLine );
            } else {
                index = data.findIndex ( (obj) => obj.branchCode === row.branchCode && obj.DeliveryLine === this.state.deliveryLine );
            }
            if(index > -1) {
                data[index].Inactive = state;
            }
        });
        
        this.setState({
            branchesData:data
        });
    }
    */
    /*
    htmlTableTHProductQtyUnit = () => {
        let array = [];
        for(let i = 0; i < 10; i++) {
            array.push(i);
        }
        return array.map( (row, index) => {
            return (
                <>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Unit</th>
                </>
            );
        });
    }
    */
    
    /* Branch with/without PO */
    htmlBranchPOSummary = () => {
        const branchesData = this.state.branchesData.filter( (obj) => obj.DeliveryLine === this.state.deliveryLine );
        
        let branchCount = [];
        let withCount = 0;
        let orderCount = 0;

        branchesData.forEach( (row) => {
            let branchDepPurchaseOrders = this.getBranchDepPurchaseOrders(row.branchCode, row.DepId);
            orderCount = orderCount + branchDepPurchaseOrders.length;

            let index = branchCount.findIndex( (obj) => obj.branchCode === row.branchCode );

            if(index === -1) {
                branchCount.push({
                    branchCode:row.branchCode,
                    po:branchDepPurchaseOrders.length > 0 ? true : false
                });
                if(branchDepPurchaseOrders.length > 0) {
                    withCount++;
                }
            } else {
                if(!branchCount[index].po) {
                    if(branchDepPurchaseOrders.length > 0) {
                        branchCount[index].po = true;
                        withCount++;
                    }
                }
            }
        });

        let data = {
            with:withCount,
            without:(branchCount.length - withCount)
        }

        return (
            <Row>
                <Col xs={7} >
                    <div className="mb-2">
                        <span className="font-weight-bold">該車線客戶數:</span> {branchCount.length}
                        <span className="mx-2">|</span>
                        <span className="font-weight-bold">已落單客戶數:</span> {data.with}
                        <span className="mx-2">|</span>
                        <span className="font-weight-bold">未落單客戶數:</span> {data.without}
                    </div>
                </Col>
                <Col xs={5}>
                    <div className="text-end delivery-date-label-wrapper" >
                        <span className="font-weight-bold">訂單數: {orderCount}</span>
                        <span className="font-weight-bold only-print2" >校對人:_________</span>
                    </div>
                </Col>
            </Row>
        );
    }

    htmlTableBranches = () => {
        let data = this.state.branchesData.filter( (obj) => obj.DeliveryLine === this.state.deliveryLine || obj.transferLine === this.state.deliveryLine);
        //console.log("TABLE DATA: ", data, this.state.deliveryLine)
        return data.map( (row, index) => {
            let isTransferred = row.transferLine !== -1 && row.transferLine !== this.state.deliveryLine;
            let branchDepPurchaseOrders = this.getBranchDepPurchaseOrders(row.branchCode, row.DepId);
            const QA = this.getDeliveryLineBranchQA(row.BranchId);
            return (
                <div  key={index} className={row.Inactive || isTransferred ? 'table-logistics-wrapper table-logistics-inactive' : 'table-logistics-wrapper'}>
                    <Table className="table-logistics">
                        <tbody key={index}>
                            <tr>
                                <th className="table-logistics-branch" colSpan="50">
                                   <div className="d-table w-100">
                                        <div className="d-table-row">
                                            <div className="d-table-cell align-top">
                                                <span className="table-logistics-branch-label text-nowrap">
                                                    <span className="table-logistics-serial">#{index + 1}</span> ({row.branchCode}) {row.BranchName} {row.DepName !== DEPARTMENT_DEFAULT ? row.DepName: ""} {/*isTransferred ? <span className="font-weight-bold">*已轉線*</span> : ""*/}
                                                    {QA && <i>(<Check2Circle size={16} className="mr-1 text-success" /> 不落單)</i>}
                                                </span>
                                            </div>
                                            {(branchDepPurchaseOrders.length > 0 || isTransferred) &&  
                                            <div className="d-table-cell col-no-padding align-top">
                                                <span className="table-logistics-info">
                                                        {!isTransferred ? (
                                                            branchDepPurchaseOrders.length > 1 ? (
                                                                <ExclamationCircle size={32} className="my-1 text-danger" />
                                                            ) : (
                                                                <span className="table-logistics-remark">
                                                                    {branchDepPurchaseOrders.length > 0 && branchDepPurchaseOrders[0].Remark}
                                                                </span>
                                                            )
                                                        ) : (
                                                            <span className="font-weight-bold">*已轉線*</span>
                                                        )}
                                                </span>
                                            </div>
                                            }
                                        </div>
                                   </div>    
                                </th>
                            </tr>
                        
                            {/*<td>{row.BranchName}</td>*/}
                            {this.htmlTableBranchDepProducts(row.branchCode, row.DepId, row.DepName, row.transferLine)}
                        </tbody>
                    </Table>
                </div>
            ) 
        });
    }

    htmlTableDeliveryLine = () => {

        let deliveryLineTable = [];
        let _totalLooseProducts = this.state.inventoryMappingData.filter(prod =>
            this.state.branchesData.some(branch =>
                prod.BranchCode === branch.branchCode
            )
        );

        const totalLooseProducts = _totalLooseProducts.reduce((acc, curr) => {
            const exists = acc.some(item =>
              item.GoodsCode === curr.GoodsCode
            );
            if (!exists) {
              acc.push(curr);
            }
            return acc;
        }, []);

        totalLooseProducts.forEach((tlp) => {
            tlp.looseTotal = 0;
            tlp.picking = {
                "件":"",
                "隻":"",
                "包":""
            }
        })

        for(let i = 0; i < totalLooseProducts.length; i++) {
            totalLooseProducts[i].looseTotal = 0;
            totalLooseProducts[i].picking = {
                "件":"",
                "隻":"",
                "包":""
            }
        }

        // Iterate over all delivery lines
        this.state.deliveryLinesData.map( (row, index) => {

            // const branchesData = this.state.branchesData.filter( (obj) => obj.DeliveryLine === row.DeliveryId );

            // Get all products mapped to branches within this delivery line
            const deliveryLineMappings = this.state.inventoryMappingData.filter(prod =>
                this.state.branchesData.some(branch =>
                    prod.BranchCode === branch.branchCode && ((branch.DeliveryLine === row.DeliveryId && branch.transferLine === -1) || branch.transferLine === row.DeliveryId) 
                )
            );

            // Reduce to unique products mapped to this delivery line
            const deliveryLineProducts = deliveryLineMappings.reduce((acc, curr) => {
                const exists = acc.some(item =>
                  item.GoodsCode === curr.GoodsCode
                );
                if (!exists) {
                  acc.push(curr);
                }
                return acc;
            }, []);

                let pickingNumbers = [];
                let pickingNumbersLoose = [];
                let productsTable = deliveryLineProducts.map( (product, index) => {
                    // objective is to get the unit quantity for all products..
                    let picking = {
                        "件":"",
                        "隻":"",
                        "包":""
                    }
                    //let productPicking = this.calculateProductPickingQty(product.GoodsCode, product.GoodsFormatName);

                    let productPicking = 0;

                    // let inventoryMapping = this.state.inventoryMappingData.filter((obj) => obj.GoodsCode === product.GoodsCode)[0];

                    let purchaseOrdersItemsQty = this.state.purchaseOrdersItemsQtyData.filter( (poi) =>
                        poi.GoodsCode === product.GoodsCode && 
                        this.state.branchesData.some(branch =>
                            poi.BranchCode === branch.branchCode && ((branch.DeliveryLine === row.DeliveryId && branch.transferLine === -1) || branch.transferLine === row.DeliveryId) 
                            )
                    );

                    if(purchaseOrdersItemsQty) {
                        let packagingUnitNum = this.getPackingUnitNum(product.GoodsCode);
                        purchaseOrdersItemsQty.forEach( (item) => {
                            let num = item.Num;
                            if(item.GoodsFormatName === product.GoodsFormatName) {
                                num = item.Num * packagingUnitNum
                            }
        
                            if(productPicking === 0) {
                                productPicking = num;
                            } else {
                                productPicking = productPicking + num; 
                            }
                        });

                    }

                    let packingUnitNum = this.getPackingUnitNum(product.GoodsCode);
                    // how many units can go into the package?
                    if(productPicking > 0) {
                        
                        let floor = Math.floor(productPicking / packingUnitNum);
                        
                        if(product.UnitName === '付') {
                            product.UnitName = '隻';
                        }
    
                        // TEMP override 箱 to 件
                        if(product.GoodsFormatName === '箱') {
                            product.GoodsFormatName = '件';
                        }
    
                        if(floor > 0 && packingUnitNum > 1) {
                            // we can increment the packaging
                            picking[product.GoodsFormatName] = floor;
                            // what ever remains goes into the unit
                            picking[product.UnitName] = productPicking - floor * packingUnitNum;
                        } else {
                            picking[product.UnitName] = productPicking;
                        }
                        
                        if(picking[product.UnitName] === 0) {
                            picking[product.UnitName] = "";
                        }
                    }

                    pickingNumbers.push({"product" : product.GoodsName, "productTotal" : productPicking, "picking" : picking});
                    if (picking['隻'] !== '' || picking['包'] !== '') {
                        pickingNumbersLoose.push({"GoodsCode" : product.GoodsCode, "product" : product.GoodsName, "productTotal" : productPicking, "picking" : picking});
                        let looseRecord = totalLooseProducts.findIndex(lp => lp.GoodsCode === product.GoodsCode);
                        if(looseRecord) {
                            let edgeAdjuster = 1;
                            if (picking['隻'] !== '') {
                                // HARD CODE SPECIAL EDGE CASE WHERE 5盒(包) -> 1隻
                                if (product.GoodsCode === "OF34") {
                                    edgeAdjuster = packingUnitNum;
                                }
                                totalLooseProducts[looseRecord].looseTotal = totalLooseProducts[looseRecord].looseTotal + picking['隻'] * edgeAdjuster;
                            } else if (picking['包'] !== '') {
                                let packAdjuster = 1;
                                if(product.UnitName === '隻') {
                                    packAdjuster = packingUnitNum
                                }
                                totalLooseProducts[looseRecord].looseTotal = totalLooseProducts[looseRecord].looseTotal + picking['包'] * packAdjuster;
                            }
                        }
                    }
                    return null;
                });
            
            let split = []

            while (pickingNumbersLoose.length > 0) {
              split.push(pickingNumbersLoose.splice(0, 6));
            }
            if (split.length > 0) {
                for(let i = split[split.length-1].length; i < 6; i++) {
                    split[split.length-1].push({
                        "product":"",
                        "productTotal":"",
                        "picking": {
                            "件":"",
                            "隻":"",
                            "包":""
                        }
                    })
                };
            }

            deliveryLineTable.push({"DeliveryLine" : row.Label, "products" : split})
            
            //let isPO = false;
            return (
                <div  key={index} className={row.Inactive ? 'table-logistics-wrapper table-logistics-inactive' : 'table-logistics-wrapper'}>
                    <Table className="table-logistics">
                        <tbody key={index}>
                            <tr>
                                <th className="table-logistics-branch" colSpan="50">
                                   <div className="d-table w-100">
                                        <div className="d-table-row">
                                            <div className="d-table-cell align-top">
                                                <span className="table-logistics-branch-label text-nowrap">
                                                    {row.Label}
                                                </span>
                                            </div>
                                        </div>
                                   </div>    
                                </th>
                            </tr>
                            {productsTable}
                        </tbody>
                    </Table>
                </div>

            )
        });

        this.totalLooseProducts = totalLooseProducts;

        return deliveryLineTable.map( (line, index) => {
            return (
                <div  key={index} className='table-logistics-wrapper'>
                    <Table className="table-logistics">
                        <tbody key={index}>
                            <tr>
                                <th className="table-logistics-branch table-logistics-inactive" colSpan="50">
                                   <div className="d-table w-100">
                                        <div className="d-table-row">
                                            <div className="d-table-cell align-top">
                                                <span className="table-logistics-branch-label text-nowrap">({line.DeliveryLine})</span>
                                            </div>
                                        </div>
                                   </div>    
                                </th>
                            </tr>
                            {line.products.map( (row, index) => {
                                return (
                                    <tr key={index}>
                                        {row.map( (cell, index) => {
                                            let className = "";
                                            let borderRight = "td-border-right-thin";
                                            if(row.length === index + 1) {
                                                borderRight = "";
                                            }
                                            return (
                                                <React.Fragment key={`td-products-${index}`}>
                                                <td className={`td-goodsName ${className}`}>{cell.product}</td>
                                                <td className={`td-goodsNum ${className}`}>{cell.picking['隻'] !== '' ? cell.picking['隻'] : cell.picking['包']}</td>
                                                <td className={`td-goodsUnit ${className} ${borderRight}`}>{cell.picking['隻'] !== '' ? '隻' : cell.picking['包'] !== '' ? '包' : ''}</td>
                                                </React.Fragment>
                                            )
                                        })}
                                    </tr>
                                )
                            }
                            )}
                        </tbody>
                    </Table>
                    </div>
            ) 
        });
    }

    getDeliveryLineBranchQA = (branchId) => {
        return this.state.deliveryLinesQAData.filter( (row) => {
            return row.BranchId === branchId
        })[0];
    }

    htmlTableBranchDepProducts = (BranchCode, DepId, DepName, TransferLine) => {

        let isTransferred = TransferLine !== -1 && TransferLine !== this.state.deliveryLine

        let data;
        if(DepName === DEPARTMENT_DEFAULT) {
            data = this.state.inventoryMappingData.filter( (obj) => obj.BranchCode.toString() === BranchCode );
       <div class="text-end only-print delivery-date-label-wrapper mb-2">…</div> } else {
            data = this.state.inventoryMappingData.filter( (obj) => obj.BranchCode.toString() === BranchCode && obj.DepId === DepId );
        }
        
        for(let i = data.length; i < 30; i++) {
            data.push({
                "GoodsName":"",
                "GoodsFormatName":"",
                "DepId":0
            })
        }

        // format the array of objects into array of 'array objects', each array holds maximum of 6 objects
        let array = [];
        let _data = [];
        data.forEach( (obj, index) => {
            array.push(obj);
            if((index + 1) % 6 === 0) {
                // check that the array is not 'empty'
                let empty = true;
                array.forEach( (foo) => {
                    if(foo.GoodsName !== "") {
                        empty = false;
                    }                    
                });
                if(!empty) {
                _data.push(array);
                }
                array = [];
            }
            
        });

        //does the branch/Dep have more than one PO
        let branchDepPurchaseOrders = this.getBranchDepPurchaseOrders(BranchCode, DepId);

        if(isTransferred || branchDepPurchaseOrders.length < 2) {
            let html = _data.map((array, indexRow) => {
                return (
                    <tr key={indexRow}>
                        {
                        array.map( (product, indexProduct) => {           
                            let className = "";
                            let borderRight = "td-border-right-thin";
                            if(array.length === indexProduct + 1) {
                                borderRight = "";
                            }
                            const qty = this.getPurchaseOrdersItemsQty(product.BranchCode, DepId, product.GoodsCode, product.branchGoodsFormatName);
                            return (
                                <React.Fragment key={`product-${indexProduct}`}>
                                <td className={`td-goodsName ${className}`}>{product.GoodsName}</td>
                                <td className={`td-goodsNum ${className}`} >{isTransferred ? "" : qty}</td>
                                <td className={`td-goodsUnit ${qty === "" ? "td-goodsUnit-normal" : "td-goodsUnit-bold"} ${className} ${borderRight}`}>{product.branchGoodsFormatName}</td>
                                </React.Fragment>
                            );
                        })
                        }
                    </tr>    
                );
            });

            return html;
        } else {
            let html = branchDepPurchaseOrders.map( (po, index) => {
                return (
                    <React.Fragment key={`po-${index}`}>
                    {
                    <tr className="td-purchaseOrder" key={index}>
                        <td colSpan="60" className="td-purchaseOrder">
                            <div className="d-table w-100">
                                <div className="d-table-row">
                                    <div className="d-table-cell align-middle">
                                    <Button variant="link" className="px-0" onClick={() => window.open(`/purchase-order/${po.POId}`)}>
                                        {/*<Window size={16} className="mr-1 mb-1" />*/}
                                        {po.OrderName}
                                    </Button>
                                    </div>
                                    {
                                    po.Remark
                                    ?
                                        <div className="d-table-cell align-middle">
                                            <span className="table-logistics-info">
                                                <span className="table-logistics-remark">{po.Remark}</span>
                                            </span>
                                        </div>
                                    :
                                        ""
                                    }
                                </div>
                            </div>
                        </td>
                    </tr>
                    }
                    {this.htmlPurchaseOrdersQty(po, _data)}
                    </React.Fragment>
                )    
            });
            
            return (
                <>
                    {html}
                    {
                    <tr className="td-purchaseOrder">
                        <td colSpan="60" className="td-purchaseOrder td-purchaseOrderTotal">
                            <span className="font-weight-bold">總數</span>
                        </td>
                    </tr>
                    }
                    {this.htmlPurchaseOrdersQty({POId:0}, _data)}
                </>
            );
        }
    }

    getBranchDepPurchaseOrders = (BranchCode, DepId) => {
        
        let branchDepPurchaseOrders = [];
        
        if(DepId > 0) {
            branchDepPurchaseOrders = this.state.purchaseOrdersItemsQtyData.filter( (obj) => obj.BranchCode === BranchCode && obj.DepId === DepId );
        } else {
            branchDepPurchaseOrders = this.state.purchaseOrdersItemsQtyData.filter( (obj) => obj.BranchCode === BranchCode );
        }
       
        let purchaseOrders = [];
        branchDepPurchaseOrders.forEach( (obj) => {
            if(purchaseOrders.findIndex( (order) => obj.POId === order.POId) === -1) {
                purchaseOrders.push({
                    POId:obj.POId,
                    OrderName:obj.OrderName,
                    Remark:obj.Remark
                });
            }
        });

        return purchaseOrders;
    }

    htmlPurchaseOrdersQty = (po, _data) => {
        let html = _data.map((array, indexRow) => {
            return <tr key={indexRow}>
            {
            array.map( (product, indexProduct) => {
                let className = "";
                let borderRight = "td-border-right-thin";
                if(array.length === indexProduct + 1) {
                    borderRight = "";
                }
                const qty = this.getPurchaseOrdersItemsQty(product.BranchCode, product.DepId, product.GoodsCode, product.branchGoodsFormatName, po.POId);
                return (
                    <React.Fragment key={`td-products-${indexProduct}`}>
                    <td className={`td-goodsName ${className}`}>{product.GoodsName}</td>
                    <td className={`td-goodsNum ${className}`} >{qty}</td>
                    <td className={`td-goodsUnit ${qty === "" ? "td-goodsUnit-normal" : "td-goodsUnit-bold"} ${className} ${borderRight}`}>{product.branchGoodsFormatName}</td>
                    </React.Fragment>
                );
            })
            }
        </tr>
        });

        return html;
    }

    

    getPurchaseOrdersItemsQty = (BranchCode, DepId, GoodsCode, GoodsFormatName, POId) => {
     
        /*
        BranchCode: "AA047"
        GoodsCode: "BB03"
        GoodsFormatId: 135
        GoodsFormatName: "隻"
        GoodsId: 2858
        Num: 7
        */
        let qty = "";
        if(BranchCode && GoodsCode && GoodsFormatName) {
            let data = [];
            if(POId) {
                data = this.state.purchaseOrdersItemsQtyData.filter( (obj) => 
                obj.BranchCode === BranchCode &&
                obj.GoodsCode === GoodsCode &&
                obj.GoodsFormatName === GoodsFormatName && 
                obj.POId === POId
                );
            } else {
                if(DepId > 0) {
                    data = this.state.purchaseOrdersItemsQtyData.filter( (obj) => 
                    obj.BranchCode === BranchCode &&
                    obj.DepId === DepId &&
                    obj.GoodsCode === GoodsCode &&
                    obj.GoodsFormatName === GoodsFormatName
                    );
                } else {
                    data = this.state.purchaseOrdersItemsQtyData.filter( (obj) => 
                    obj.BranchCode === BranchCode &&
                    obj.GoodsCode === GoodsCode &&
                    obj.GoodsFormatName === GoodsFormatName
                    );
                }
            }

            if(data.length > 0) {
                let num = 0;
                data.forEach( (obj) => {
                    num = num + obj.Num;
                });
                qty = num;
            }

            /*
            if(BranchCode) {
                if(this.getTableLogisticsInactive(BranchCode, DepId) === true && qty > 0) {
                    this.setTableLogisticsInactive(BranchCode, DepId, false);
                }
            }
            */
        }

        if(!qty) {
            qty = "";
        }

        return qty;
    }

    getProducts = (data) => {
        // this.state.inventoryMappingData
        /*
        BranchCode: "BF003"
        GoodsCode: "BB01"
        GoodsFormatName: "隻"
        GoodsName: "BB"
        */

        let products = [];
        data.forEach( (product, index) => {
            if(products.findIndex( (obj) => obj.GoodsCode === product.GoodsCode )) {
                products.push(product);
            }
        });

        return products;
    }

    getPigeonProducts = () => {
        let data = [];
        let dataFiltered = this.state.inventoryMappingData.filter( (obj) => obj.GoodsCode.toLowerCase().substring(0,2) === 'bb' );
        dataFiltered.forEach( (obj) => {
            if(data.indexOf(obj.GoodsCode) === -1) {
                data.push(obj.GoodsCode);
            }
        });
        return data;
    }


    getProductGroupings = (products) => {
        const branchesData = this.getBranchesDataPerLine();

        const isLooseProducts = products.every(obj => "looseTotal" in obj);

        return productGroupings.map(group => {
            const { groupId, groupName, itemIdLists } = group;

            const updatedItemLists = itemIdLists.map(itemIdList => {
                const { listId, listName, itemIds } = itemIdList;
                let _items = [];

                if (isLooseProducts) {
                    _items = products.filter(item =>
                        itemIds.findIndex((itemId) => itemId === item.ItemId) > -1
                    )
                } else {
                    _items = products.filter(item =>
                    branchesData.findIndex((obj) => obj.branchCode === item.BranchCode) > -1 &&
                    itemIds.findIndex((itemId) => itemId === item.ItemId) > -1
                )
                }
                const items = [];
                _items.forEach((item) => {
                    if (items.findIndex((obj) => obj.GoodsCode === item.GoodsCode) === -1) {
                        items.push(item);
                    }
                });
                return { listId, listName, items };
            });

            return { groupId, groupName, itemLists: updatedItemLists };
        });
    }

    getGroupProductCounts = (productsData, isLooseProducts) => {
        const groupProductCounts = {};

        productsData.forEach(group => {
            const { groupId, itemLists } = group;
            let itemCount = 0;
            if (isLooseProducts) {
            itemCount = itemLists.reduce((count, itemList) => {
                const looseItemCount = itemList.items.reduce((sum, item) => {
                  return sum + (item.looseTotal > 0 ? 1 : 0);
                }, 0);
                return count + looseItemCount;
              }, 0);
            } else {
            itemCount = itemLists.reduce((count, itemList) => count + itemList.items.length, 0);
            }

            const itemListCount = itemLists.filter(itemList => {
                if (isLooseProducts) {
                  return itemList.items.some(item => item.looseTotal > 0);
                } else {
                  return itemList.items.length > 0;
                }
              }).length;

            //const itemListCount = itemLists.length;

            groupProductCounts[groupId] = {
                itemListCount: itemListCount,
                productCount: itemCount,
                minLength: 2 * itemListCount + itemCount
            };
        });
        return groupProductCounts;
    }

    htmlTableGroupedColumn = (group, columnRows, colNo, isLooseProducts) => {
        const tableRows = [];
        const emptyRow = {
            "BranchCode": "",
            "GoodsCode": "",
            "GoodsFormatName": "",
            "GoodsName": ""
        }

        const subTotalRow = {
            ...emptyRow,
            "GoodsName": "小計："
        }

        const supplementOrderRow = {
            ...emptyRow,
            "GoodsName": "後補訂單："
        }

        let subtotal = 0;

        group.itemLists.forEach((itemList, index) => {
            let notEmptyList = false;
            itemList.items.forEach(item => {
                if (isLooseProducts) {
                    if (item.looseTotal > 0) {
                        tableRows.push(item);
                        notEmptyList = true;
                    }
                } else {
                    tableRows.push(item)
                    notEmptyList = true;
                }
            })
            if (notEmptyList) {
                tableRows.push(subTotalRow);
                tableRows.push(emptyRow);
            }
        })
        for(let i = tableRows.length; i < columnRows; i++) {
            tableRows.push(emptyRow);
        }
        colNo === 0 ? tableRows.push(supplementOrderRow) : tableRows.push(emptyRow);;
        tableRows.push(emptyRow);

        const htmlColumn = tableRows.map((row, index) => {
            let picking = {
                "件":"",
                "隻":"",
                "包":""
            }
            const product = row;
            if (isLooseProducts) {
                if(product.GoodsName === "") {
                    subtotal = 0;
                }    
                if(product.looseTotal > 0) {
                    let packingUnitNum = this.getPackingUnitNum(product.GoodsCode);
                    if(product.GoodsCode === "OF34") {
                        //console.log("PACKING UNIT NUM: ", packingUnitNum)
                        //console.log("HMMM>>>>>", product)
                    }
                    let floor = Math.floor(product.looseTotal / packingUnitNum);
                    if(product.UnitName === '付') {
                        product.UnitName = '隻';
                    }

                    // TEMP override 箱 to 件
                    if(product.GoodsFormatName === '箱') {
                        product.GoodsFormatName = '件';
                    }

                    if(floor > 0 && packingUnitNum > 1) {
                        // we can increment the packaging
                        picking[product.GoodsFormatName] = floor;
                        if(row.GoodsFormatName === '件') {
                            subtotal = subtotal + floor;
                            this.grandTotalGroupedLooseProducts = this.grandTotalGroupedLooseProducts + floor;
                        } else {
                            subtotal ++;
                            this.grandTotalGroupedLooseProducts ++;
                        }
                        // what ever remains goes into the unit
                        picking[product.UnitName] = product.looseTotal - floor * packingUnitNum;
                    } else {
                        picking[product.UnitName] = product.looseTotal;
                    }
                    
                    if(picking[product.UnitName] === 0) {
                        picking[product.UnitName] = "";
                    } else {
                        subtotal ++;
                        this.grandTotalGroupedLooseProducts ++;
                    }
                }
            } else {
                let productPicking = this.calculateProductPickingQty(row.GoodsCode, row.GoodsFormatName);
                // Reset subtotal on empty line
                if(row.GoodsName === "") {
                    subtotal = 0;
                }
                if(productPicking.total > 0) {
                    let packingUnitNum = this.getPackingUnitNum(row.GoodsCode);
                    let floor = Math.floor(productPicking.total / packingUnitNum);
                    
                    if(row.UnitName === '付') {
                        row.UnitName = '隻';
                    }

                    // TEMP override 箱 to 件
                    if(row.GoodsFormatName === '箱') {
                        row.GoodsFormatName = '件';
                    }

                    if(floor > 0 && packingUnitNum > 1) {
                        // we can increment the packaging
                        picking[row.GoodsFormatName] = floor;
                        if (!row.GoodsName.includes("醃制費")) {
                            if(row.GoodsFormatName === '件') {
                                subtotal = subtotal + floor;
                                this.grandTotalGroupedProducts = this.grandTotalGroupedProducts + floor;
                            } else {
                                subtotal ++;
                                this.grandTotalGroupedProducts ++;
                            }
                        }
                        // what ever remains goes into the unit
                        picking[row.UnitName] = productPicking.total - floor * packingUnitNum;
                        //console.log("PRODUCT PIECE: ", product.GoodsName, floor, picking[product.UnitName], product.UnitName, product.GoodsFormatName)
                    } else {
                        picking[row.UnitName] = productPicking.total;
                    }
                    
                    if(picking[row.UnitName] === 0) {
                        picking[row.UnitName] = "";
                    } else {
                        if (!row.GoodsName.includes("醃制費")) {
                            subtotal ++;
                            this.grandTotalGroupedProducts ++;
                        }
                        //console.log("PRODUCT LOOSE: ", product.GoodsName, picking[product.UnitName])
                    }
                }
            }
            //console.log("TOTAL CHECK: ", index, this.grandTotalGroupedProducts)
            if(!row.GoodsName) {
                return (
                    <tr key={index} className={index === (tableRows.length - 2) ? "supp-order-border" : null}>
                        <td>{row.GoodsName}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                );
            } else {
                return (
                    <tr key={index} className={index === (tableRows.length - 2) ? "supp-order-border" : null}>
                        {
                            row.GoodsName === '後補訂單：' ? <td className="fw-bold">{row.GoodsName}</td> : 
                            row.GoodsName === '小計：' ? <td className="fw-bold" style={{textAlign:'right'}}>{row.GoodsName}{subtotal} 件</td> : 
                            <td>{row.GoodsName}</td>
                        
                        }
                        {<td className="text-center fw-bold">{picking['件']}</td>}
                        {<td className="text-center fw-bold">{picking['隻']}</td>}
                        {<td className="text-center fw-bold">{picking['包']}</td>}
                    </tr>
                );
            }
        })
        /*<Table className={`${tableRows.length > 25 ? "ls-page-break-24" : tableRows.length > 24 ? "ls-page-break-23" : tableRows.length > 23 ? "ls-page-break-22" : null } mb-0 h-100-unset h-100 table-pick-grouped-col`} hover>*/
        return (
            <Table className={` mb-0 h-100-unset h-100 table-pick-grouped-col`} hover>
            
                <thead>
                    <tr>
                        <th className="text-left">發貨人：</th>
                        <td colSpan="3" className="fw-bold text-center">數量</td>
                    </tr>
                    <tr>
                    <th className="align-middle">產品</th>
                        <th>件</th>
                        <th>隻</th>
                        <th>包</th>
                    </tr>
                </thead>
                <tbody>
                    {htmlColumn}
                </tbody>
            </Table>
        )

    }
    htmlTableGroupedProducts = (products) => {
        const isLooseProducts = products.every(obj => "looseTotal" in obj);
        const productsData = this.getProductGroupings(products);
        const groupProductCounts = this.getGroupProductCounts(productsData, isLooseProducts);
        const maxMinLength = Math.max(...Object.values(groupProductCounts).map(obj => obj.minLength));
        
        this.grandTotalGroupedProducts = 0;
        this.grandTotalGroupedLooseProducts = 0;

        const productsColumns = productsData.map((group, index) => {
            return (
                <div key={index} className="col col-no-padding">
                    {this.htmlTableGroupedColumn(group, maxMinLength, index, isLooseProducts)}
                </div>
            )
        });
        
        return (
                <div className="table-grouped table-pick">
                            {productsColumns}
                </div>
        )
    }


    htmlTableProducts = (code, products, maxLength, unit, exclude) => {  
      
        let branchesData = this.getBranchesDataPerLine();
        let productsData = [];
        let _productsData = [];
        let len = 33;

        if(code) {
            _productsData = this.state.inventoryMappingData.filter( (product) => {
                return (branchesData.findIndex( (obj) => obj.branchCode === product.BranchCode) > -1) && 
                (product.GoodsCode.toLowerCase().charAt(1) === code.toLowerCase() || products.indexOf(product.GoodsCode) > -1) &&  (exclude.indexOf(product.GoodsCode) === -1)
            });
        } else {
            _productsData = this.state.inventoryMappingData.filter( (product) => 
            branchesData.findIndex( (obj) => obj.branchCode === product.BranchCode) > -1 && 
            product.GoodsCode.toLowerCase().charAt(1) !== 'd' &&
            product.GoodsCode.toLowerCase().charAt(1) !== 'g' &&
            product.GoodsCode.toLowerCase().charAt(1) !== 'h' &&
            exclude.indexOf(product.GoodsCode) === -1
            );
            // only show the products from this array
            if(products.length) {
                _productsData = _productsData.filter( (product) => products.indexOf(product.GoodsCode) > -1 );
                //len = products.length;
            }
        }
        _productsData.forEach( (product) => {
            if(productsData.findIndex( (obj) => obj.GoodsCode === product.GoodsCode) === -1 ) {
                productsData.push(product);
            }
        });
        let productLength = productsData.length;
        if(maxLength) {
            //if (code === 'D' || code === 'G' || code === 'H') {
                len = productsData.length + 7;
            //} else {
            //    len = productsData.length + 4;
            //}
            productsData.push({
                "BranchCode": "",
                "GoodsCode": "",
                "GoodsFormatName": "",
                "GoodsName": "小計："
            });
            productsData.push({
                "BranchCode": "",
                "GoodsCode": "",
                "GoodsFormatName": "",
                "GoodsName": "後補訂單："
            });
        }
        for(let i = productsData.length; i < len; i++) {
            productsData.push({
                "BranchCode": "",
                "GoodsCode": "",
                "GoodsFormatName": "",
                "GoodsName": ""
            });
        }
        if(!maxLength) {
            if (productsData[productsData.length - 6].GoodsName === ""){
                productsData[productsData.length - 6].GoodsName = "小計："
                productsData[productsData.length - 5].GoodsName = "後補訂單："
            } else {
                if (productsData.length - productLength > 2) {
                    productsData[productLength].GoodsName = "小計："
                    productsData[productLength + 1].GoodsName = "後補訂單："
                }
            }
        }

        let subtotal = 0;
        let productsTable = productsData.map( (product, index) => {
            // objective is to get the unit quantity for all products..
            //if(product.GoodsCode === "XH06") {
                let picking = {
                    "件":"",
                    "隻":"",
                    "包":""
                }
                let productPicking = this.calculateProductPickingQty(product.GoodsCode, product.GoodsFormatName);
                //console.log("NORMAL PRODUCT PICKING: ", product.GoodsCode, product.GoodsFormatName, productPicking)
                
                // how many units can go into the package?
                if(productPicking.total > 0) {
                    let packingUnitNum = this.getPackingUnitNum(product.GoodsCode);
                    let floor = Math.floor(productPicking.total / packingUnitNum);
                    
                    if(product.UnitName === '付') {
                        product.UnitName = '隻';
                    }

                    // TEMP override 箱 to 件
                    if(product.GoodsFormatName === '箱') {
                        product.GoodsFormatName = '件';
                    }

                    if(floor > 0 && packingUnitNum > 1) {
                        // we can increment the packaging
                        picking[product.GoodsFormatName] = floor;
                        if (!product.GoodsName.includes("醃制費")) {
                            if(product.GoodsFormatName === '件') {
                                subtotal = subtotal + floor;
                            } else {
                                subtotal ++;
                            }
                        }
                        // what ever remains goes into the unit
                        picking[product.UnitName] = productPicking.total - floor * packingUnitNum;
                        //console.log("PRODUCT PIECE: ", product.GoodsName, floor, picking[product.UnitName], product.UnitName, product.GoodsFormatName)
                    } else {
                        picking[product.UnitName] = productPicking.total;
                    }
                    
                    if(picking[product.UnitName] === 0) {
                        picking[product.UnitName] = "";
                    } else {
                        if (!product.GoodsName.includes("醃制費")) {
                            subtotal ++;
                        }
                        //console.log("PRODUCT LOOSE: ", product.GoodsName, picking[product.UnitName])
                    }
                }

            if(!product.GoodsName) {
                return (
                    <tr key={index}>
                        <td>{product.GoodsName}</td>
                        {(unit === '件' || !unit) && <td></td>}
                        {(unit === '隻' || !unit) && <td></td>}
                        {(unit === '包' || !unit) && <td></td>}
                    </tr>
                );
            } else {
                return (
                    <tr key={index}>
                        {
                            product.GoodsName === '後補訂單：' ? <td className="fw-bold">{product.GoodsName}</td> : 
                            product.GoodsName === '小計：' ? <td className="fw-bold" style={{textAlign:'right'}}>{product.GoodsName}{subtotal} 件</td> : 
                            <td>{product.GoodsName}</td>
                        
                        }
                        {(unit === '件' || !unit) && <td className="text-center fw-bold">{picking['件']}</td>}
                        {(unit === '隻' || !unit) && <td className="text-center fw-bold">{picking['隻']}</td>}
                        {(unit === '包' || !unit) && <td className="text-center fw-bold">{picking['包']}</td>}
                    </tr>
                );
            }
        });

        //console.log("Subtotal: ", code, subtotal);
        
        return (
            <Table className="mb-0 h-100" hover>
                <thead>
                    <tr>
                        <th className="text-left">發貨人：</th>
                        <td colSpan="3" className="fw-bold text-center">數量</td>
                    </tr>
                    <tr>
                    <th className="align-middle">產品</th>
                        <th>件</th>
                        <th>隻</th>
                        <th>包</th>
                    </tr>
                </thead>
                <tbody>
                    {productsTable}
                    <tr>
                        <td colSpan="4" className="text-center"><label className="font-weight-bold" style={{marginTop:'0.2rem',marginBottom:'0.2rem'}}> 合計：</label></td>
                    </tr>
                </tbody>
            </Table>
        )
    }

    htmlTableLooseProducts = (code, products, maxLength, unit, exclude) => {  
      
        //let branchesData = this.getBranchesDataPerLine();
        let productsData = [];
        let _productsData = [];
        let len = 25;

        if(code) {
            _productsData = this.totalLooseProducts.filter( (product) => {
                //console.log("=====exclude: ", exclude, "=====PRODUCT: ", product, "LOGIG: ", exclude.indexOf(product.GoodsCode) === -1)
                return ((product.GoodsCode.toLowerCase().charAt(1) === code.toLowerCase() || products.indexOf(product.GoodsCode) > -1) && exclude.indexOf(product.GoodsCode) === -1)
            });

            if(maxLength) {
                len = productsData.length;
            }
        } else {
            _productsData = this.totalLooseProducts.filter( (product) => 
            product.GoodsCode.toLowerCase().charAt(1) !== 'd' &&
            product.GoodsCode.toLowerCase().charAt(1) !== 'g' &&
            product.GoodsCode.toLowerCase().charAt(1) !== 'h' &&
            exclude.indexOf(product.GoodsCode) === -1
            );
            // only show the products from this array
            if(products.length) {
                _productsData = _productsData.filter( (product) => products.indexOf(product.GoodsCode) > -1 );
                //len = products.length;
            }
        }
        _productsData.forEach( (product) => {
            if(productsData.findIndex( (obj) => obj.GoodsCode === product.GoodsCode) === -1 ) {
                if(product.looseTotal > 0) {
                    productsData.push(product);
                }
            }
        });
        if(maxLength) {
            len = productsData.length;
        }

        for(let i = productsData.length; i < len; i++) {
            productsData.push({
                "BranchCode": "",
                "GoodsCode": "",
                "GoodsFormatName": "",
                "GoodsName": ""
            });
        }
        
        let productsTable = productsData.map( (product, index) => {
            // objective is to get the unit quantity for all products..
            //if(product.GoodsCode === "XH06") {
                let picking = {
                    "件":"",
                    "隻":"",
                    "包":""
                }
                //let productPicking = this.calculateProductPickingQty(product.GoodsCode, product.GoodsFormatName);
                //console.log("product", product)
                
                // how many units can go into the package?
                if(product.looseTotal > 0) {
                    let packingUnitNum = this.getPackingUnitNum(product.GoodsCode);
                    if(product.GoodsCode === "OF34") {
                        //console.log("PACKING UNIT NUM: ", packingUnitNum)
                        //console.log("HMMM>>>>>", product)
                    }
                    //console.log("PACKING UNIT NUM: ", packingUnitNum)
                    let floor = Math.floor(product.looseTotal / packingUnitNum);
                    //console.log("FLOOR: ", floor)
                    //console.log("GOODSFORMATNAME: ", product.GoodsFormatName);
                    //console.log("UNIT NAME: ",  picking[product.UnitName]);
                   
                    
                    if(product.UnitName === '付') {
                        product.UnitName = '隻';
                    }

                    // TEMP override 箱 to 件
                    if(product.GoodsFormatName === '箱') {
                        product.GoodsFormatName = '件';
                    }

                    if(floor > 0 && packingUnitNum > 1) {
                        // we can increment the packaging
                        picking[product.GoodsFormatName] = floor;
                        // what ever remains goes into the unit
                        picking[product.UnitName] = product.looseTotal - floor * packingUnitNum;
                    } else {
                        picking[product.UnitName] = product.looseTotal;
                    }
                    
                    if(picking[product.UnitName] === 0) {
                        picking[product.UnitName] = "";
                    }
                }

            if(!product.GoodsName) {
                return (
                    <tr key={index}>
                        <td>{product.GoodsName}</td>
                        {(unit === '件' || !unit) && <td></td>}
                        {(unit === '隻' || !unit) && <td></td>}
                        {(unit === '包' || !unit) && <td></td>}
                    </tr>
                );
            } else {
                return (
                    <tr key={index}>
                        <td>{product.GoodsName}</td>
                        {(unit === '件' || !unit) && <td className="text-center">{picking['件']}</td>}
                        {(unit === '隻' || !unit) && <td className="text-center">{picking['隻']}</td>}
                        {(unit === '包' || !unit) && <td className="text-center">{picking['包']}</td>}
                    </tr>
                );
            }
        });
        
        return (
            <Table className="mb-0 h-100" hover>
                <thead>
                    <tr>
                        <th rowSpan="2" className="align-middle">產品</th>
                        <td colSpan="3" className="fw-bold text-center">數量</td>
                    </tr>
                    <tr>
                        <th>件</th>
                        <th>隻</th>
                        <th>包</th>
                    </tr>
                </thead>
                <tbody>
                    {productsTable}
                </tbody>
            </Table>
        )
    }
    
    getPackingUnitNum = (GoodsCode) => {
        let item = this.state.purchaseOrdersItemsData.filter( (obj) => obj.GoodsCode === GoodsCode )[0];
        if(item) {
            return item.GoodsFormatNumber;
        }
        return 0;
    }

    getBranchesDataPerLine = () => {
        return this.state.branchesData.filter( (obj) => (obj.DeliveryLine === this.state.deliveryLine && obj.transferLine === -1) || this.state.deliveryLine === obj.transferLine );
    }

    calculateProductPickingQty = (GoodsCode, GoodsFormatName) => {
        let total = 0;
        let inventoryMapping = this.state.inventoryMappingData.filter((obj) => obj.GoodsCode === GoodsCode)[0];
                
        if(inventoryMapping) {

            // is the product for a branch within the delivery line?
            let branchesData = this.getBranchesDataPerLine();

            let purchaseOrdersItemsQty = this.state.purchaseOrdersItemsQtyData.filter( (obj) => 
                obj.GoodsCode === inventoryMapping.GoodsCode && 
                //obj.GoodsFormatName === GoodsFormatName &&
                branchesData.findIndex( (branch) => branch.branchCode === obj.BranchCode) > -1 
            );
        
            if(purchaseOrdersItemsQty) {
                let packagingUnitNum = this.getPackingUnitNum(GoodsCode);
                purchaseOrdersItemsQty.forEach( (item) => {
                    let num = item.Num;
                    if(item.GoodsFormatName === GoodsFormatName) {
                        num = item.Num * packagingUnitNum;
                    }

                    if(total === 0) {
                        total = num;
                    } else {
                        total = total + num; 
                    }
                });
            }
        }

        if(total > 0) {
            return {
                total:total,
                //GoodsCode:inventoryMapping.GoodsCode                
            }
        } else {
            return {
                total: 0,
                //GoodsCode:inventoryMapping.GoodsCode
            }
        }
    }

    handleRequestedDateChange = (date) => {
        this.setState({
            isLoading:true,
            requestedDeliveryDate:date,
            branchesData:this.resetBranchesDataInactive()
        }, () => {
            this.getTemporaryDeliveryLinesAPI();
            this.getPurchaseOrdersItemsQtyAPI();
        });
    }

    htmlPrintDeliveryDateStamp = () => {
        return (
            <div className="text-left only-print delivery-date-label-wrapper mb-2">
                <h4 className="mb-0">
                    <Calendar4 size={16} className="mr-1 no-print" /> <label className="font-weight-bold">送貨日期</label> {moment(this.state.requestedDeliveryDate).format('DD MMM YYYY')}    
                </h4>
            </div>
        )
    }

    htmlPrintTimeStamps = () => {
        return (
            <div className="text-end only-print delivery-date-label-wrapper mb-2">
                <div><label className="font-weight-bold">打印用戶</label> {this.props.auth.operatorName}</div>
                <Calendar4 size={16} className="mb-1 mr-1 no-print" /> <label className="font-weight-bold">打印時間</label> {moment().format('h:mm:ssa DD MMM YYYY')}
            </div>
        )
    }

    htmlPrintDeliverySelectors = () => {
        //console.log("Print Delivery Selectors")
        return (
            <div className="mt-4 no-print">
            <Row>
                <Col xs={6}>
                    <div className="d-inline-block">
                        <DropdownButton 
                        id="dropdown-delivery-line"
                        title={this.getDeliveryLineDropDownTitle()}
                        onSelect={this.handleOnSelectDeliveryLine}
                        value={this.state.deliveryLine}
                        >
                            {this.htmlDropDownItems()}
                        </DropdownButton>
                    </div>
                    {this.state.deliveryLine > 0 &&
                    <div className="d-inline-block ml-1">
                        <Button 
                        variant="link" 
                        type="button" 
                        className="mr-1" 
                        onClick={ () => this.handleOnClickRefresh()}
                        >
                            <ArrowClockwise size={32} className="mb-1 mr-1" />
                            Refresh
                        </Button>
                    </div>
                    }
                </Col>
            </Row>                                    
        </div>
        )
    }

    htmlPrintDeliveryDate = () => {
        //console.log("Print Delivery Selectors")
        return (
            <div className="mt-4 no-print">
            <Row>
                <Col xs={12} className="text-end">
                    <Calendar4 size={16} className="mb-1 mr-1" /> <label className="font-weight-bold">送貨日期</label>
                    <div>
                        <SingleDatePicker
                        date={this.state.requestedDeliveryDate} // momentPropTypes.momentObj or null
                        onDateChange={date => this.handleRequestedDateChange(date)} // PropTypes.func.isRequired
                        focused={this.state.focused} // PropTypes.bool
                        onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        id="requested_delivery_date" // PropTypes.string.isRequired,
                        displayFormat={() => "DD/MM/YYYY"}
                        isOutsideRange={() => false}
                        isDayHighlighted={(day) => {
                            if(this.state.poStorageDatesData.indexOf(moment(day).format('YYYY-MM-DD')) > -1) {
                                return true;
                            }
                            return false;
                        }}
                        />
                    </div>
                </Col>
            </Row>                                    
        </div>
        )
    }

    htmlPrintPickerReceiver = (total) => {
        return (
            <div className="only-print delivery-date-label-wrapper mb-1" style={{marginTop: '1rem'}}>
                <h4 className="mb-0">
                    <label>倉務人:_______&nbsp;&nbsp;收貨人:_______&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;小計共&nbsp;&nbsp;{total}&nbsp;&nbsp;件/加單________件&nbsp;&nbsp;共計________件</label>
                </h4>
            </div>
        )
    }

    htmlPrintSectionHeader = (section) => {
        return (
            <Row>
                <Col xs={7}>
                    <h3>{section} ({this.getDeliveryLineTitle()})</h3>
                    {this.htmlPrintDeliveryDateStamp()}
                </Col>
                <Col xs={5}>
                    {this.htmlPrintTimeStamps()}
                </Col>
            </Row>
        )
    }

    htmlPrintLandscapeHeader = (section) => {
        return (
            <Row>
                <Col >
                    <h3>{section} ({this.getDeliveryLineTitle()})</h3>
                </Col>
                <Col >
                    {this.htmlPrintDeliveryDateStamp()}
                </Col>
                <Col  className="text-end only-print delivery-date-label-wrapper mb-2">
                    <label className="font-weight-bold">打印用戶</label> {this.props.auth.operatorName}
                </Col>
                <Col  className="text-end only-print delivery-date-label-wrapper mb-2">
                    <Calendar4 size={16} className="mb-1 mr-1 no-print" /> <label className="font-weight-bold">打印時間</label> {moment().format('h:mm:ssa DD MMM YYYY')}
                </Col>
            </Row>
        )
    }


    htmlPrintPickDelivery = () => {
        return (
            <>
            {this.state.deliveryLine > 0 && 
                <>                                        
                <div className="mt-4 min-width-960">
                    {this.htmlPrintSectionHeader("客戶訂單")}
                    {this.htmlBranchPOSummary()}
                    {this.htmlTableBranches()}
                </div>
                
                {false && this.props.auth.supplierNum !== "TS" &&
                <>        
                <div className="page-break"></div>

                    <div className="mt-4 min-width-960">
                        {this.htmlPrintSectionHeader("執貨紙")}
                        <div className="table-logistics-wrapper">
                            <Table className="table-pick h-100">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                                {this.htmlTableProducts('D',[], false,'',[])}
                                        </td>
                                        <td className="table-pick-col col-no-padding">
                                                    {this.htmlTableProducts('G',[],false,'',[])}
                                        </td>
                                        <td className="table-pick-col col-no-padding">
                                                    {this.htmlTableProducts('H',[],false,'',[])}
                                        </td>
                                        <td className="table-pick-col col-no-padding">
                                                    {this.htmlTableProducts('',[],false,'',[])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                        {this.htmlPrintPickerReceiver()}
                    </div>
                </>
                }
                
                {/*{this.props.auth.supplierNum !== "TS" && */}
                {false &&
                    <>
                        <div className="page-break"></div>
                        <div className="mt-4 min-width-960">
                            {this.htmlPrintSectionHeader("鴨物流記錄")}
                            <div className="table-logistics-wrapper">
                            <Table className="table-pick">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                            {this.htmlTableProducts('D',[],true,'',[])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                            {this.htmlPrintPickerReceiver()}
                        </div>
                        <div className="page-break"></div>
                        <div className="mt-4 min-width-960">
                            {this.htmlPrintSectionHeader("鵝物流記錄")}
                            <div className="table-logistics-wrapper">
                            <Table className="table-pick">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                            {this.htmlTableProducts('G',['OF00'],true,'',[])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                            {this.htmlPrintPickerReceiver()}
                        </div>
                        {/*                        
                        <div className="page-break"></div>
                        <div className="mt-4 min-width-960">
                            {this.htmlPrintSectionHeader("雞物流記錄")}
                            <div className="table-logistics-wrapper">
                            <Table className="table-pick">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                            {this.htmlTableProducts('H',[],true,'',[])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                            {this.htmlPrintPickerReceiver()}
                        </div>
                        */}
                        <div className="page-break"></div>
                        <div className="mt-4 min-width-960">
                            {this.htmlPrintSectionHeader("鴿物流記錄")}
                            <div className="table-logistics-wrapper">
                            <Table className="table-pick">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                            {this.htmlTableProducts('',this.getPigeonProducts(),true,'',[])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                            {this.htmlPrintPickerReceiver()}
                        </div>
                        <div className="page-break"></div>
                        <div className="mt-4 min-width-960" style={{breakInside: 'avoid'}}>
                            {this.htmlPrintSectionHeader("什物流記錄")}
                            <div className="table-logistics-wrapper">
                            <Table className="table-pick">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                            {this.htmlTableProducts('F',[],true,'',['OF00'])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                            {this.htmlPrintPickerReceiver()}
                        </div>
                    </>
                }
                </>
            }
            </>
        )
    }

    htmlPrintPickLoose = () => {
        return (
            <>

                <>                                        
                <div className="mt-4 min-width-960">
                    <Row>
                        <Col xs={7}>
                            <h3>車線散件匯總</h3>
                        </Col>
                        <Col xs={5}>
                            {this.htmlPrintTimeStamps()}
                        </Col>
                    </Row>
                    {this.htmlTableDeliveryLine()}
                </div>
                
                {this.props.auth.supplierNum !== "TS" &&
                <>        
                <div className="page-break"></div>

                    <div className="mt-4 min-width-960">
                        <Row>
                    <Col xs={7}>
                        <h3>散件執貨紙</h3>
                    </Col>
                    <Col xs={5}>
                            {this.htmlPrintTimeStamps()}
                        </Col>
                        </Row>
                        <div className="table-logistics-wrapper">
                            <Table className="table-pick h-100">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                                {this.htmlTableLooseProducts('D',[], false,'',[])}
                                        </td>
                                        <td className="table-pick-col col-no-padding">
                                                    {this.htmlTableLooseProducts('G',[],false,'',[])}
                                        </td>
                                        <td className="table-pick-col col-no-padding">
                                                    {this.htmlTableLooseProducts('H',[],false,'',[])}
                                        </td>
                                        <td className="table-pick-col col-no-padding">
                                                    {this.htmlTableLooseProducts('',[],false,'',[])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </>
                }
                
                {this.props.auth.supplierNum !== "TS" &&
                    <>
                        <div className="page-break"></div>
                        
                        <div className="mt-4 min-width-960">
                            <Row>
                        <Col xs={7}>
                            <h3>散件鵝物流記錄</h3>
                        </Col>
                        <Col xs={5}>
                            {this.htmlPrintTimeStamps()}
                        </Col>
                        </Row>
                            <div className="table-logistics-wrapper">
                            <Table className="table-pick">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                            {this.htmlTableLooseProducts('G',['OF00'],true,'',[])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                        </div>
                        <div className="mt-1 only-print">&nbsp; </div>
                        <div className="mt-4 min-width-960">
                            <Row>
                            <Col xs={7}>
                                <h3>散件鴿物流記錄</h3>
                            </Col>
                            <Col xs={5}>
                            {this.htmlPrintTimeStamps()}
                        </Col>
                        </Row>
                            <div className="table-logistics-wrapper">
                            <Table className="table-pick">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                            {this.htmlTableLooseProducts('',this.getPigeonProducts(),true,'',[])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                        </div>
                        <div className="mt-1 only-print">&nbsp; </div>
                        <div className="mt-4 min-width-960">
                            <Row>
                                <Col xs={7}>
                                    <h3>散件什物流記錄</h3>
                                </Col>
                                <Col xs={5}>
                                    {this.htmlPrintTimeStamps()}
                                </Col>
                            </Row>
                            <div className="table-logistics-wrapper">
                            <Table className="table-pick">
                                <tbody>
                                    <tr>
                                        <td className="table-pick-col col-no-padding">
                                            {this.htmlTableLooseProducts('F',[],true,'',['OF00'])}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            </div>
                        </div>
                    </>
                }
                </>

            </>
        )
    }

    isSevereError = () => {
        if(this.state.authError || this.state.serverError) {
            return true;
        }
        return false;        
    }

    handleRenderDayContents = (day) => {
        //Change week day with custom day array
        console.log(day);
        this.SingleDatePickerDates.push(day);
        return (day.format('D'));
    }

    handleMonthClick = async (dir) => {
     this.SingleDatePickerDates = [];
    }

    handleSelectTab = (value) => {
        value = parseInt(value);
        if(value === 1) {
            this.setState({
                looseTabActive:false
            });
        } else if( value === 2 ) {
            this.setState({
                looseTabActive:true
            });
        } 
        
    }

    lsPrintScale = (products) => {
        //let products = this.state.inventoryMappingData;
        const isLooseProducts = products.every(obj => "looseTotal" in obj);
        const productsData = this.getProductGroupings(products);
        const groupProductCounts = this.getGroupProductCounts(productsData, isLooseProducts);
        const maxMinLength = Math.max(...Object.values(groupProductCounts).map(obj => obj.minLength));
        return maxMinLength > 26 ? "ls-print-scale-80" : maxMinLength === 26 ? "ls-print-scale-88" : maxMinLength === 25 ? "ls-print-scale-91" : maxMinLength === 24 ? "ls-print-scale-94" : maxMinLength < 24 ? "ls-print-scale-97" : ""
    }
    
    render() {
        return (
            <>
            <Container fluid className="p-0 m-0">
                {this.props.auth.isLogin && <NavbarComponent />}
                <Container className="print-layout">
                    <div className="mt-4 no-print">
                        <Row>
                            <Col xs={6}>
                                <h1>Pick & Delivery</h1>
                            </Col>
                            {!this.state.isLoading && (this.state.deliveryLine > 0 || this.state.looseTabActive) &&
                            <Col xs={6} className="text-end">
                                <div>
                                    <Button type="button" variant="secondary" onClick={ () => window.print()}>Print Page</Button>  
                                </div>
                            </Col>
                            }
                        </Row>
                    </div>

                    {
                    this.isSevereError()
                    ?
                        <>
                            {this.state.authError && <AuthErrorComponent />}
                            {this.state.serverError && <ServerErrorComponent />}
                        </>
                    :
                    <>
                        <Row>
                            <Col xs={12}>
                                {
                                    !this.state.apiErrorMessage &&
                                    (
                                        this.state.isLoading || 
                                        !this.state.branchesAPI || 
                                        !this.state.inventoryMappingAPI || 
                                        !this.state.purchaseOrdersItemsQtyAPI || 
                                        !this.state.purchaseOrdersItemsByPOIdAPI ||
                                        !this.state.deliveryLinesAPI ||
                                        !this.state.poStorageDatesAPI
                                    )
                                    ?
                                        <LoadingComponent />
                                    :
                                    this.state.apiErrorMessage
                                    ?
                                        <div className="mt-4 no-print">
                                            <AlertErrorComponent label={this.state.apiErrorMessage} />
                                        </div>
                                    :
                                    <>
                                        {this.htmlPrintDeliveryDate()}

                                        <Tabs 
                                    //defaultActiveKey={!this.props.poType ? 1 : this.props.poType} 
                                    //activeKey={!this.props.poType ? 1 : this.props.poType}
                                    id="approval-tab" 
                                    className="mt-4 no-print" 
                                    onSelect={ (value) => this.handleSelectTab(value)}
                                    >
                                        <Tab eventKey={1} title="Pick & Delivery">
                                            {this.htmlPrintDeliverySelectors()}
                                            <div className="portrait-section mb-4">
                                                {this.htmlPrintPickDelivery()}
                                            </div>
                                            <div className="landscape-section page-break">
                                                {this.state.deliveryLine > 0 &&
                                                    this.props.auth.supplierNum !== "TS" &&
                                                    <>
                                                        <div className={`${this.lsPrintScale(this.state.inventoryMappingData)} mt-4 ls-print min-width-960`}>
                                                            {this.htmlPrintLandscapeHeader("執貨紙")}
                                                            {/*this.htmlPrintSectionHeader("執貨紙 Grouped")*/}
                                                            {this.htmlTableGroupedProducts(this.state.inventoryMappingData)}
                                                            {this.htmlPrintPickerReceiver(this.grandTotalGroupedProducts)}
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </Tab>
                                        <Tab eventKey={2} title="Pick Loose Items">
                                            <div className="mb-4">
                                                {this.htmlPrintPickLoose()}
                                            </div>
                                            <div className="p-0 landscape-section">
                                                {this.state.deliveryLine > 0 &&
                                                    this.props.auth.supplierNum !== "TS" &&
                                                    <>
                                                        <div className={`${this.lsPrintScale(this.totalLooseProducts)} mt-4 ls-print min-width-960`}>
                                                        <Row>
                                                            <Col >
                                                                <h3>散件什物流記錄</h3>
                                                            </Col>
                                                            <Col >
                                                                {this.htmlPrintDeliveryDateStamp()}
                                                            </Col>
                                                            <Col  className="text-end only-print delivery-date-label-wrapper mb-2">
                                                                <label className="font-weight-bold">打印用戶</label> {this.props.auth.operatorName}
                                                            </Col>
                                                            <Col  className="text-end only-print delivery-date-label-wrapper mb-2">
                                                                <Calendar4 size={16} className="mb-1 mr-1 no-print" /> <label className="font-weight-bold">打印時間</label> {moment().format('h:mm:ssa DD MMM YYYY')}
                                                            </Col>
                                                        </Row>
                                                            {this.htmlTableGroupedProducts(this.totalLooseProducts)}
                                                            {this.htmlPrintPickerReceiver(this.grandTotalGroupedLooseProducts)}
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </Tab>
                                    </Tabs> 
                                    </>

                                }
                            </Col>
                        </Row>
                    </>
                    }
                </Container>
            </Container>
            <FooterComponent />
            </>
        )
    }

}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

export default connect(mapStateToProps, null)(withRouter(SupplierLogisticsPickLoose));